import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight, Sparkles, Star, Heart } from "lucide-react";
import { motion } from "framer-motion";

const floatingIcons = [
  { Icon: Star, delay: 0, x: -120, y: -60 },
  { Icon: Heart, delay: 0.2, x: 140, y: -40 },
  { Icon: Sparkles, delay: 0.4, x: -160, y: 40 },
  { Icon: Star, delay: 0.6, x: 180, y: 60 },
  { Icon: Heart, delay: 0.1, x: -80, y: 80 },
  { Icon: Sparkles, delay: 0.3, x: 100, y: -80 },
];

const CTASection = () => {
  return (
    <section className="py-20 sm:py-28 relative">
      <div className="container mx-auto relative z-10">
        <motion.div 
          className="relative max-w-3xl mx-auto text-center p-8 sm:p-12 rounded-[2rem] bg-card/60 backdrop-blur-sm border border-border/50 shadow-paper"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          {/* Floating decorative icons around the card */}
          {floatingIcons.map(({ Icon, delay, x, y }, index) => (
            <motion.div
              key={index}
              className="absolute hidden sm:block text-primary/10"
              style={{ left: '50%', top: '50%' }}
              initial={{ opacity: 0, scale: 0 }}
              whileInView={{ 
                opacity: 1, 
                scale: 1,
                x: x,
                y: y,
              }}
              viewport={{ once: true }}
              transition={{ 
                delay: delay + 0.3,
                duration: 0.5,
                type: "spring",
                stiffness: 200
              }}
            >
              <motion.div
                animate={{ 
                  y: [0, -8, 0],
                  rotate: [0, 5, -5, 0]
                }}
                transition={{ 
                  duration: 3 + index * 0.5,
                  repeat: Infinity,
                  ease: "easeInOut"
                }}
              >
                <Icon className="w-4 h-4 sm:w-5 sm:h-5" />
              </motion.div>
            </motion.div>
          ))}

          {/* Soft glow behind content */}
          <div className="absolute inset-0 rounded-[2rem] bg-gradient-to-br from-primary/5 via-transparent to-secondary/5 pointer-events-none" />

          <div className="relative z-10">
            <motion.div
              initial={{ opacity: 0, scale: 0.8 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ delay: 0.2 }}
              className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gradient-to-br from-gold to-orange mb-6 shadow-magic"
            >
              <Sparkles className="w-8 h-8 text-white" />
            </motion.div>

            <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-bold text-foreground mb-4 sm:mb-6">
              Redo att skapa en unik bok?
            </h2>
            
            <p className="text-lg sm:text-xl text-muted-foreground mb-8 sm:mb-10 max-w-2xl mx-auto">
              Ge ditt barn en personlig berättelse de aldrig glömmer – det tar bara några minuter.
            </p>

            <motion.div 
              className="flex flex-col sm:flex-row items-center justify-center gap-4"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.2 }}
            >
              <Button variant="cta" size="lg" className="text-sm sm:text-base" asChild>
                <Link to="/create" className="flex items-center gap-2 group">
                  Kom igång gratis
                  <ArrowRight className="w-4 h-4 sm:w-5 sm:h-5 group-hover:translate-x-1 transition-transform" />
                </Link>
              </Button>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default CTASection;
